import React, { useEffect, useState } from 'react';
import PageHeader from '../../PageHeader/PageHeader';
import { HitApi } from '../../Api/ApiHit';
import { searchBooking } from '../../constant/Constant';
import { useDispatch, useSelector } from 'react-redux';
import { setApiJson } from '../../redux/Actions/ApiAction';
import AppTable from '../../components/AppTable/AppTable';
import AppPagination from '../../components/Pagination/AppPagination';
import { setPagination } from '../../redux/Actions/TableAction';

function Appointments() {
  const dispatch = useDispatch();
  const ApiReducer = useSelector((state) => state.ApiReducer);
  const TableDataReducer = useSelector((state) => state.TableReducer);
  
  useEffect(() => {
    getAppointments();
  }, [TableDataReducer.pagination.page, TableDataReducer.pagination.limit]);
  
  const getAppointments = () => {
    const json = {
      page: TableDataReducer.pagination.page,
      limit: TableDataReducer.pagination.limit,
      search: {}
    };
    
    HitApi(json, searchBooking).then((res) => {
      console.log("res", res);
      if (res?.statusCode === 200) {
        dispatch(setApiJson(res?.data));
        
        // Update pagination data in Redux
        const paginationData = {
          total: res?.totalDocs || 0,
          page: TableDataReducer.pagination.page,
          limit: TableDataReducer.pagination.limit
        };
        
        dispatch(setPagination(paginationData));
      }
    }).catch(error => {
      console.error("Error fetching appointments:", error);
    });
  };

  // Get service names based on the config.services array
  const getServiceNames = (appointment) => {
    if (!appointment?.config?.services || !appointment.config.services.length) return 'N/A';
    return appointment.config.services.join(', ');
  };

  // Handle appointment actions
  const handleReschedule = (row) => {
    console.log("Reschedule appointment:", row);
    // Implementation for rescheduling
  };

  const handleCancel = (row) => {
    console.log("Cancel appointment:", row);
    if (window.confirm(`Are you sure you want to cancel this appointment for ${row.customer_name}?`)) {
      // Implementation for cancellation
    }
  };

  // Define status badge renderer
  const renderStatus = (status) => {
    if (!status) return null;
    
    let bgColor = "bg-gray-100";
    let textColor = "text-gray-800";
    
    switch(status.toLowerCase()) {
      case "upcoming":
        bgColor = "bg-green-100";
        textColor = "text-green-800";
        break;
      case "pending":
        bgColor = "bg-yellow-100";
        textColor = "text-yellow-800";
        break;
      case "cancelled":
        bgColor = "bg-red-100";
        textColor = "text-red-800";
        break;
      case "passed":
      case "completed":
        bgColor = "bg-blue-100";
        textColor = "text-blue-800";
        break;
    }
    
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
        {status}
      </span>
    );
  };

  // Get base index for serial numbers
  const baseIndex = (TableDataReducer.pagination.page - 1) * TableDataReducer.pagination.limit;

  // Define table headers based on actual data structure
  const tableHeaders = [
    { 
      title: "S.No", 
      key: "serialNumber", 
      width: "60px", 
      align: "center",
      render: (_, row, index) => {
        // Calculate serial number based on current page and limit
        const serialNumber = baseIndex + index + 1;
        return (
          <div className="text-center">
            <span className="text-sm font-medium text-gray-900">{serialNumber}</span>
          </div>
        );
      }
    },
    { 
      title: "Client", 
      key: "customer_name",
      render: (value) => value || 'N/A'
    },
    { 
      title: "Services", 
      key: "services",
      render: (_, row) => getServiceNames(row)
    },
    { 
      title: "Date", 
      key: "bill_date", 
      render: (value) => value || 'N/A'
    },
    { 
      title: "Time", 
      key: "time", 
      render: (value) => value || 'N/A'
    },
    { 
      title: "Specialist", 
      key: "staffIdMongoId",
      render: (value) => value?.name || 'Not Assigned'
    },
    { 
      title: "Amount", 
      key: "grandtotal",
      render: (value) => {
        return `₹${parseFloat(value || 0).toLocaleString()}`;
      }
    },
    { 
      title: "Status", 
      key: "status", 
      render: renderStatus
    },
   
  ];

  // Handle row click if needed
  const handleRowClick = (row) => {
    console.log("Appointment details:", row);
    // Show appointment details or open a modal
  };

  return (
    <div className="p-5">
      <PageHeader
        title={'Appointments'}
        description={'Schedule and manage client appointments'}
      />
      <AppTable 
        TH={tableHeaders}
        TD={ApiReducer.apiJson || []}
        onRowClick={handleRowClick}
        isLoading={!ApiReducer.apiJson?.length}
        emptyMessage="No appointments found"
        buttonText="New Appointment"
        navigateTo="/add-appointment"
      />
    </div>
  );
}

export default Appointments;